import template from './confirmModal.html';
import controller from './confrimModal.controller';

let ConfirmModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-warning animated zoomIn"
};

export default ConfirmModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/ConfirmModal/confirmModal.component.js